import React, { useState, useEffect } from "react";
import { useStyles } from "../../admin/adminStyles";
import { useSelector, useDispatch } from "react-redux";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import {
    DB_DATE_FORMAT,
    DISPLAY_DATE_FORMAT,
  } from '../../../redux/constants';
import {
    getAppUserList,
    getAppUser,
} from "../../../redux/appUsers/appUserActions";
import {
    getRequests,
    updateRequest,
    deleteRequest,
    getRequestsByDate
} from "../../../redux/ptoRequests/ptoRequestsActions";
import { Grid ,Button} from "@material-ui/core";
import {
    updateTimesheet,
    fetchTimesheet,
} from "../../../redux/timesheets/timesheetsActions";
import moment from "moment";

import VacationHourTable from "./components/VacationHourTable";
const columns = [
    { id: 'usersName', label: 'USERNAME', align: 'center' },
    { id: 'start', label: 'START DATE', align: 'center' },
    { id: 'end', label: 'END DATE', align: 'center' },
    { id: 'requestType', label: 'REQUEST TYPE', align: 'center' },
    { id: 'totalHours', label: 'HOURS', align: 'center' },
    { id: 'requestStatus', label: 'STATUS', align: 'center' },
  ];
const PtoRequestReview = props => {
    const { btnMobile,inputMobile } = useStyles();
    const currentUser = useSelector(state => state.users.currentUser);
    const ptoRequests = useSelector(state => state.ptoRequests);
    const users = useSelector(state => state.appUsers.usersList || []);
    const dispatch = useDispatch();
    const selectedUser = useSelector(
        state => state.appUsers.selectedUser || {}
    );
    let selectedTimesheet = useSelector(
        state => state.timesheets.currentTimesheet || {}
    );

    const [open, setOpen] = useState(false);
    const [dialogObj, setDialogObj] = useState({});
    const [updated, setUpdated] = useState(false);
    const [orderAscending, setOrderAscending] = useState(true);
    const [asc, setAsc] = useState('desc');
    const [activeRecords, setActiveRecords] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const handleUpdated = () => setUpdated(!updated);
    const [openToDate, setOpenToDate] = useState(false);
    
  const [fromDate, setFromDate] = useState(moment().startOf('month').format(DB_DATE_FORMAT));
  const [toDate, setToDate] = useState(moment().endOf('month').format(DB_DATE_FORMAT));
  const [searchObject,setSearchObject]=useState({
    fromDate: fromDate,
    toDate: toDate,
  });
  const bindUsers = () => dispatch(getAppUserList());
const bindRequests = () => dispatch( getRequestsByDate({...searchObject}));
    useEffect(() => {
        bindUsers();
        bindRequests();
        events();
    }, [currentUser, updated]);

    const getUserName = id => {
        let foundUser = users.find(user => user.id === id);
        return foundUser
            ? `${foundUser.firstName} ${foundUser.lastName}`
            : null;
    };
    const handleDelete = async () => {
        await dispatch(deleteRequest(dialogObj.requestId, currentUser.id));
        handleUpdated();
        handleClose();
    };

    const events = () => {
        let arr = [];
        let requests = ptoRequests.requests;
        requests &&
            requests.map(request => {
                arr.push({
                    requestId: request.id,
                    userId: request.userId,
                    requestTitle: ((request.partialHours||0)>0)&&((request.partialHours||0)<8)?`${getUserName(request.userId)} partial pto request`:`${getUserName(request.userId)} pto request`,
                    usersName: getUserName(request.userId) || "N/A",
                    totalHours:(request.partialHours||null)!=null ?request.partialHours:request.daysRequested*8,
                    start: request.startDate,
                    end: request.endDate,
                    requestType: request.requestType,
                    requestStatus: request.requestStatus,
                    partialHours:request.partialHours
                });
            });
        return arr;
    };
 let getDaysArray = (start, end) => {
        for (
            var arr = [], dt = new Date(start);
            dt <= new Date(end);
            dt.setDate(dt.getDate() + 1)
        ) {
            arr.push(new Date(dt));
        }
        return arr;
    };

    const getDays = (task, numberOfDays,partialHours, daysArray, mode) => {
        let days = [];
            for (let i = 0; i < numberOfDays; i++) {
                days.push({
                    id: null,
                    date: daysArray[i],
                    is_billable: false,
                    task: task,
                    note: "",
                    hour: (partialHours||0)==0?8:(partialHours||0),
                });
            }
      //  }
        return days;
    };

    const handleDeny = async obj => {
        let reqObj = {
            userId: obj.userId,
            startDate: obj.start,
            endDate: obj.end,
            requestType: obj.requestType,
            managerId: obj.managerId,
            requestStatus: obj.requestStatus,
            userComments: obj.userComments,
            managerComments: obj.managerComment,
            partialHours:obj.partialHours
        };

        let updatedTimesheet = {};
        let altStart = moment(obj.start).startOf("week").format("MM-DD-YYYY");
        let altEnd = moment(obj.start).endOf("week").format("MM-DD-YYYY");

        const daylist = getDaysArray(obj.start, obj.end);
        const daysArr = daylist.map(day => moment(day).format("MM-DD-YYYY"));

        updatedTimesheet = {
            fromDate: selectedTimesheet.weekly.length
                ? selectedTimesheet.weekly[0].fromDate
                : altStart,
            toDate: selectedTimesheet.weekly.length
                ? selectedTimesheet.weekly[0].toDate
                : altEnd,
            role: selectedUser.role,
            userId: obj.userId,
            ptoStatus:"Declined",
            mode: "Save",
            tsData: {
                users: [
                    {
                        id: obj.userId,
                        firstName: selectedUser.firstName,
                        middleName: selectedUser.middleName,
                        lastName: selectedUser.lastName,
                        emailId: selectedUser.emailId,
                        mobile: selectedUser.mobile,
                        role: selectedUser.role,
                        sick: selectedUser.sick,
                        vacation: selectedUser.vacation,
                        holiday: selectedUser.holiday,
                        active: selectedUser.active,
                        responseMessage: selectedUser.responseMessage,
                        weekly: [
                            {
                                tsId:
                                    selectedTimesheet.weekly[0] === undefined
                                        ? null
                                        : selectedTimesheet.weekly[0].tsId,
                                userId: obj.userId,
                                fromDate: selectedTimesheet.weekly.length
                                    ? selectedTimesheet.weekly[0].fromDate
                                    : altStart,
                                toDate: selectedTimesheet.weekly.length
                                    ? selectedTimesheet.weekly[0].toDate
                                    : altEnd,
                                comments: "",
                                status: "SUBMIT_PENDING",
                                hours: "",
                                days: getDays(
                                    obj.requestType,
                                    obj.daysRequested,
                                    obj.partialHours,
                                    daysArr,
                                    "deny"
                                ),
                            },
                        ],
                    },
                ],
            },
        };

        await dispatch(updateRequest(obj.requestId, currentUser.id, reqObj));
        await dispatch(updateTimesheet(updatedTimesheet, "save"));
        bindRequests();
        handleUpdated();
        handleClose();
    };
    const handleGo = () => {
        dispatch(
            getRequestsByDate({...searchObject})
        );
      };
    const handleApprove = async obj => {
        let updatedTimesheet = {};
        let altStart = moment(obj.start).startOf("week").format("MM-DD-YYYY");
        let altEnd = moment(obj.start).endOf("week").format("MM-DD-YYYY");

        const daylist = getDaysArray(obj.start, obj.end);
        const daysArr = daylist.map(day => moment(day).format("MM-DD-YYYY"));

        let reqObj = {
            userId: obj.userId,
            startDate: obj.start,
            endDate: obj.end,
            managerId: obj.managerId,
            requestType: obj.requestType,
            requestStatus: obj.requestStatus,
            userComments: obj.userComments,
            managerComments: obj.managerComment,
            partialHours:obj.partialHours
        };

        updatedTimesheet = {
            fromDate: selectedTimesheet.weekly.length
                ? selectedTimesheet.weekly[0].fromDate
                : altStart,
            toDate: selectedTimesheet.weekly.length
                ? selectedTimesheet.weekly[0].toDate
                : altEnd,
            role: selectedUser.role,
            userId: obj.userId,
            mode: "Save",
            ptoStatus:"Approved",
            tsData: {
                users: [
                    {
                        id: obj.userId,
                        firstName: selectedUser.firstName,
                        middleName: selectedUser.middleName,
                        lastName: selectedUser.lastName,
                        emailId: selectedUser.emailId,
                        mobile: selectedUser.mobile,
                        role: selectedUser.role,
                        sick: selectedUser.sick,
                        vacation: selectedUser.vacation,
                        holiday: selectedUser.holiday,
                        active: selectedUser.active,
                        responseMessage: selectedUser.responseMessage,
                        weekly: [
                            {
                                tsId:
                                    selectedTimesheet.weekly[0] === undefined
                                        ? null
                                        : selectedTimesheet.weekly[0].tsId,
                                userId: obj.userId,
                                fromDate: selectedTimesheet.weekly.length
                                    ? selectedTimesheet.weekly[0].fromDate
                                    : altStart,
                                toDate: selectedTimesheet.weekly.length
                                    ? selectedTimesheet.weekly[0].toDate
                                    : altEnd,
                                comments: "",
                                status: "SUBMIT_PENDING",
                                hours: "",
                                days: getDays(
                                    obj.requestType,
                                    obj.daysRequested,
                                    obj.partialHours,
                                    daysArr,
                                    "approve"
                                ),
                            },
                        ],
                    },
                ],
            },
        };

        await dispatch(updateRequest(obj.requestId, currentUser.id, reqObj));
        await dispatch(updateTimesheet(updatedTimesheet, "save"));
        bindRequests();
        handleUpdated();
        handleClose();
    };

    const getManagerComment = comment =>
        setDialogObj({ ...dialogObj, managerComment: comment });

    const handleClose = () => {
        setOpen(false);
        setDialogObj({});
    };

    const getDialogObj = obj => {
        let startVal = moment(obj.start).startOf("week");
        let endVal = moment(obj.end).endOf("week");
        let formattedStart = moment(startVal["_d"]).format("MM-DD-YYYY");
        let formattedEnd = moment(endVal["_d"]).format("MM-DD-YYYY");

        dispatch(getAppUser(obj.userId));
        dispatch(
            fetchTimesheet({
                fromDate: formattedStart,
                toDate: formattedEnd,
                role: selectedUser.role,
                userId: obj.userId,
            })
        );
        setDialogObj(obj);
    };
   
    return (
        <Grid container justify="center" alignItems="center">
            <Grid item xs={12}>
                <h1>PTO Requests</h1>
            </Grid>
            <Grid container item xs={12} md={6} spacing={1}>
          <Grid item md={5}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant='inline'
                inputVariant='outlined'
                className={inputMobile}
                format={DISPLAY_DATE_FORMAT.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                id='date-picker-inline'
                label='From Date'
                value={moment(fromDate, DB_DATE_FORMAT)}
                autoOk={true}
                onChange={date => {
                  setOpenToDate(true);
                  setFromDate(date);
                  setSearchObject({...searchObject, fromDate:date})
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
            <Grid item md={5}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                variant='inline'
                inputVariant='outlined'
                className={inputMobile}
                format={DISPLAY_DATE_FORMAT.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                id='date-picker-inline'
                open={openToDate}
                label='To Date'
                value={moment(toDate, DB_DATE_FORMAT)}
                autoOk={true}
                onChange={date => {
                  setOpenToDate(false);
                  setToDate(date);
                  setSearchObject({...searchObject, toDate:date})
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
            </MuiPickersUtilsProvider>

           
          </Grid>
         <Grid  item xs={12} md={2}>
         <Button className={btnMobile} variant='contained' onClick={handleGo}>
              Go
            </Button>
         </Grid>
          </Grid>
            <VacationHourTable
             columns={columns}
             rows={events()}
             orderAscending={orderAscending}
             asc={asc}
             activeRecords={activeRecords}
             searchTerm={searchTerm}
            ></VacationHourTable>
        </Grid>
    );
};

export default PtoRequestReview;
